import CitySpot from './CitySpot.jsx'

export default CitySpot
